export default __webpack_public_path__ + "static/media/Banking_image.ec4434f1.svg";